import { useState } from 'react';
import styles from './CopyButton.module.css';

export function CopyButton({
  value,
  label,
  className,
}: {
  value: string;
  label: string;
  className?: string;
}) {
  const [copied, setCopied] = useState(false);

  const handleClick = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      setCopied(false);
    }
  };

  return (
    <button
      type="button"
      className={className ? `${styles.button} ${className}` : styles.button}
      onClick={handleClick}
    >
      {copied ? 'Copied' : label}
    </button>
  );
}
